import { Factory } from 'lucide-react';
import type { Employee } from '@/types/tycoon';
import { PlaceholderText } from '@smartphone-tycoon/shared-ui';
import { EmployeeStatsCard } from './EmployeeStatsCard';

interface OperationsOverviewProps {
  employees?: Employee[];
  onNavigateToEmployees?: () => void;
}

export function OperationsOverview({ employees = [], onNavigateToEmployees }: OperationsOverviewProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 h-full">
      {/* Employees Section */}
      <EmployeeStatsCard 
        employees={employees}
        onClick={onNavigateToEmployees}
      />

      {/* Factories Section */}
      <div className="bg-theme-bg-content rounded-lg shadow p-6">
        <div className="flex items-center gap-2 mb-4">
          <Factory className="w-5 h-5 text-theme-success" />
          <h2 className="text-xl font-semibold text-theme-text-primary">Factories</h2>
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between items-center py-2 border-b border-theme-border">
            <span className="text-theme-text-secondary">Factories</span>
            <span className="font-semibold text-lg">1</span>
          </div>
          
          <div className="py-2">
            <div className="flex justify-between items-center mb-2">
              <span className="text-theme-text-secondary">Monthly Capacity</span>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-theme-text-muted">Current / Maximum</span>
                <span className="font-semibold"><PlaceholderText text="500,000 / 1,000,000" /></span>
              </div>
              <div className="w-full bg-theme-bg-tertiary rounded-full h-2">
                <div
                  className="bg-theme-success h-2 rounded-full transition-all duration-300"
                  style={{ width: '50%' }} // TODO: Calculate from actual utilization
                />
              </div>
              <div className="text-right">
                <span className="text-sm font-medium text-theme-success"><PlaceholderText text="50% Utilization" /></span>
              </div>
            </div>
          </div>
          
          <div className="mt-4 pt-4 border-t border-theme-border">
            <div className="space-y-2 text-sm text-theme-text-secondary">
              <div className="flex justify-between">
                <span>Average Quality Score</span>
                <span className="font-medium text-theme-text-secondary"><PlaceholderText text="92%" /></span>
              </div>
              <div className="flex justify-between">
                <span>Efficiency Rating</span>
                <span className="font-medium text-theme-text-secondary"><PlaceholderText text="85%" /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}